import { comparisonData } from "@/mocks/homeData";

export default function ComparisonSection() {
  return (
    <section className="w-full py-16 md:py-20 px-6 md:px-10 lg:px-16 bg-background-50">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-3">
            ItaoBuy Spreadsheet vs Gestione Manuale
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            Scopri perché migliaia di utenti scelgono ItaoBuy Spreadsheet per organizzare i propri acquisti.
          </p>
        </div>

        <div className="bg-background-50 rounded-2xl border border-background-200/70 overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="border-b border-background-200/70">
                  <th className="text-left px-6 py-4 font-semibold text-foreground-800 whitespace-nowrap">Funzione</th>
                  <th className="text-center px-6 py-4 font-semibold text-accent-500 whitespace-nowrap">ItaoBuy Spreadsheet</th>
                  <th className="text-center px-6 py-4 font-semibold text-foreground-500 whitespace-nowrap">Metodo Manuale</th>
                </tr>
              </thead>
              <tbody>
                {comparisonData.map((row, idx) => (
                  <tr
                    key={row.funzione}
                    className={`border-b border-background-200/70 ${
                      idx % 2 === 0 ? "bg-background-50" : "bg-background-100/50"
                    }`}
                  >
                    <td className="px-6 py-4 text-foreground-700 whitespace-nowrap">{row.funzione}</td>
                    <td className="px-6 py-4 text-center text-accent-500 font-semibold whitespace-nowrap">{row.itaobuy}</td>
                    <td className="px-6 py-4 text-center text-foreground-500 whitespace-nowrap">{row.manuale}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="mt-8 text-center">
          <p className="text-foreground-500 text-xs">
            * I punteggi rappresentano la valutazione media degli utenti ItaoBuy Spreadsheet
          </p>
        </div>
      </div>
    </section>
  );
}